var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    click: _vm.to,
  },on:{"click":function($event){return _vm.goTo(_vm.to)}}},[(_vm.isVideo)?_c('video',{staticClass:"img-fluid",attrs:{"src":_vm.src,"muted":"","playsinline":"","controls":"","preload":"metadata"},domProps:{"muted":true}}):_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.src,"alt":"Image"}})])}
var staticRenderFns = []

export { render, staticRenderFns }